import { IDataSource, IServiceKeysConfiguration } from "./IDataSource";
import { IDataSourceData } from "./IDataSourceData";
import { PagingBehavior } from './PagingBehavior';
import { IDataContext } from './IDataContext';
import { FilterBehavior } from '../filters/FilterBehavior';
import { ITemplateSlot } from './ITemplateSlot';
import { IDataFilter } from '../..';

export abstract class BaseDataSource<T, TContext = any> implements IDataSource {

    protected serviceScope: any;

    protected _properties: T;
    private _serviceKeys: IServiceKeysConfiguration;
    private _context: TContext;
    private _editMode: boolean;
    private _render: () => void | Promise<void>;

    get properties(): T {
        return this._properties;
    }

    set properties(properties: T) {
        this._properties = properties;
    }

    get render(): () => void | Promise<void> {
        return this._render;
    }

    set render(renderFunc: () => void | Promise<void>) {
        this._render = renderFunc;
    }

    get context(): TContext {
        return this._context;
    }

    set context(context: TContext) {
        this._context = context;
    }

    get serviceKeys(): IServiceKeysConfiguration {
        return this._serviceKeys;
    }

    set serviceKeys(keys: IServiceKeysConfiguration) {
        this._serviceKeys = keys;
    }

    public constructor(serviceScope: any) {
        this.serviceScope = serviceScope;
    }

    get editMode() {
        return this._editMode;
    }

    set editMode(editMode: boolean) {
        this._editMode = editMode;
    }

    public onInit(): void | Promise<void> {
    }

    public abstract getData(dataContext?: IDataContext): Promise<IDataSourceData>;

    public getPropertyPaneGroupsConfiguration(): any[] {

        // Returns an empty configuration by default
        return [];
    }

    public getPagingBehavior(): PagingBehavior {

        // Paging by default
        return PagingBehavior.Dynamic;
    }

    public getFilterBehavior(): FilterBehavior {

        // Filtering capabilioty by default
        return FilterBehavior.Static;
    }

    public getAppliedFilters(): IDataFilter[] {
        return [];
    }

    public abstract getItemCount(): number;

    public getTemplateSlots(): ITemplateSlot[] {

        // No slots by default
        return [];
    }

    public onPropertyUpdate(propertyPath: string, oldValue: any, newValue: any): void {
        // Do nothing by default      
    }

    public getSortableFields(): string[] {
        // No sortable fields by default
        return [];
    }

    public async getItemsPreview(data: IDataSourceData, slots: { [key: string]: string }): Promise<IDataSourceData> {
        // Default implementation - return data unchanged
        // Derived classes should override this method to provide preview enhancement logic
        return data;
    }
}